// extracted by mini-css-extract-plugin
export default {"WelcomeToArms_151_10496":"WelcomeToArms_WelcomeToArms_151_10496__dHqht"};